@import (reference) '~ss-ui-client/src/constants/spacing.module.less';

.header {
  align-items: center;
  justify-content: space-between;
}

.pending-return-header {
  justify-content: flex-end;
}

.item-content {
  margin: @space-8 @space-16 @space-16;
}

.cancel-button {
  margin-left: auto;
}

.carrier-logo {
  width: 40px;
  height: 40px;
}

.rate-refresh-icon {
  padding: 0;
}
